import React from 'react';
import TrustLayout from './TrustLayout';
import { PRODUCT_NAME } from '../../config/appBranding';

const LAST_UPDATED = 'April 2026';

export default function PrivacyPage() {
  return (
    <TrustLayout title="Privacy" eyebrow="Trust" lastUpdated={LAST_UPDATED}>
      <p>
        This page describes what information we collect when you use {PRODUCT_NAME},
        how we use it, and your options. Plain-English first; a formal policy is being prepared.
      </p>

      <h2>What we collect</h2>
      <p>
        <strong>Account data.</strong> Your name, work email, and role within your organization. Your password is stored as a salted hash &mdash; we never see or store the plaintext.
      </p>
      <p>
        <strong>Operational data you enter.</strong> KPI goals and actuals, attendance entries, vacation requests, approvals, and audit events. This data belongs to your organization &mdash; we process it on your behalf.
      </p>
      <p>
        <strong>Session data.</strong> A short-lived session token stored in an HttpOnly, Secure, SameSite=Lax cookie so you stay signed in across page loads.
      </p>

      <h2>What we don't collect</h2>
      <ul>
        <li>No third-party analytics, ad-tech, or trackers on the product or this site.</li>
        <li>No selling or sharing of customer data with third parties.</li>
        <li>No marketing emails unless you opt in.</li>
      </ul>

      <h2>Where data lives</h2>
      <p>
        Data is stored in a managed PostgreSQL database in the United States. Backups are encrypted at rest. Traffic is encrypted in transit with TLS.
      </p>

      <h2>Who can see it</h2>
      <p>
        Inside your organization, access follows the role model you configure &mdash; team members see their own scorecard, location leaders see their assigned locations, executives see the portfolio. Our team can access production data only when you request support or troubleshoot an incident, and those accesses are logged.
      </p>

      <h2>Retention</h2>
      <p>
        We retain your operational data for as long as your organization is an active customer. If you leave, we'll export your data on request and delete it within 30 days. Manager records are never hard-deleted inside the product &mdash; they are marked inactive to preserve audit continuity.
      </p>

      <h2>Your options</h2>
      <p>
        You can request a copy of your account data or ask us to delete it by emailing{' '}
        <a href="mailto:support@vizionops.com">support@vizionops.com</a>.
      </p>

      <div className="trust__callout">
        <strong>Questions?</strong> Email <a href="mailto:support@vizionops.com">support@vizionops.com</a> and we'll get back to you within one business day.
      </div>
    </TrustLayout>
  );
}
